import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { useIntl } from 'react-intl-next';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { useElementBreakpoints } from '../../hooks/useElementBreakpoints';
import { ErrorButton, ErrorButtonContainer, ErrorFloatingContainer, ErrorMessage } from './error-screen-parts';
import messages from './messages';
export var UnhandledErrorScreen = function UnhandledErrorScreen(_ref) {
  var onCancel = _ref.onCancel,
    text = _ref.text;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useElementBreakpoint = useElementBreakpoints(),
    _useElementBreakpoint2 = _slicedToArray(_useElementBreakpoint, 2),
    setBreakpointsElement = _useElementBreakpoint2[0],
    breakpoint = _useElementBreakpoint2[1].breakpoint;
  return jsx(ErrorFloatingContainer, {
    ref: setBreakpointsElement,
    breakpoint: breakpoint
  }, jsx(VisuallyHidden, null, formatMessage(messages.ariaErrorTitle)), jsx(ErrorMessage, {
    breakpoint: breakpoint
  }, text), jsx(ErrorButtonContainer, null, jsx(ErrorButton, {
    autoFocus: true,
    testId: 'cancel',
    onClick: onCancel,
    appearance: "primary"
  }, formatMessage(messages.cancelLabel))));
};